import { ChangeDetectionStrategy, Component, Input } from "@angular/core";

import { CheckpointDto } from "../../models/checkpoint-dto";

@Component({
    selector: "pmt-permit-checkpoints-customer-checkpoint",
    templateUrl: "permit-checkpoints-customer-checkpoint.component.html",
    styleUrls: ["permit-checkpoints-customer-checkpoint.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class PermitCheckpointsCustomerCheckpointComponent {
    @Input() public checkpoint: CheckpointDto;
}
